<boels-store-finder-search [isHomepage]="false"></boels-store-finder-search>
<boels-store-finder-list-map
  [stores$]="stores$"
  [isRegion]="true"
></boels-store-finder-list-map>
